import Pagination from './pagination.js';
import Button from './button.js';
var parts = ['container', 'text', 'arrow'];
var baseStyleText = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  textStyle: 'text',
  mb: 1
};
var baseStyle = function baseStyle(props) {
  var paginationStyles = Pagination.baseStyle(props);
  return {
    container: paginationStyles.container,
    text: baseStyleText,
    arrow: paginationStyles.arrow
  };
};
var sizes = {
  sm: {
    text: {
      fontSize: Button.sizes.sm.fontSize
    },
    arrow: Button.sizes.sm
  },
  md: {
    text: {
      fontSize: Button.sizes.md.fontSize
    },
    arrow: Button.sizes.md
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var CompactPagination = {
  parts: parts,
  sizes: sizes,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { CompactPagination as default };